import React from 'react';
import { horizontalProductPropTypes } from '@Theme/natucare/modules/Article/components/HorizontalProduct/HorizontalProductPropTypes';
import './HorizontalProduct.scss';
const HorizontalProduct = ({
  picture,
  heading,
  text,
  button,
  quote,
  ...rest
}) => {
  var _quote$image, _quote$image2;
  if (!picture && !heading && !text && !button) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "horizontalProduct"
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("figure", null, /*#__PURE__*/React.createElement("img", {
    src: picture.src,
    alt: picture.alt,
    loading: "lazy"
  }), picture.caption && /*#__PURE__*/React.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: picture.caption
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, heading), /*#__PURE__*/React.createElement("p", null, text), /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: button.href,
    className: "horizontalProduct_btn"
  }, button.label))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: quote === null || quote === void 0 ? void 0 : (_quote$image = quote.image) === null || _quote$image === void 0 ? void 0 : _quote$image.src,
    alt: quote === null || quote === void 0 ? void 0 : (_quote$image2 = quote.image) === null || _quote$image2 === void 0 ? void 0 : _quote$image2.alt,
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("figure", null, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "99",
    height: "16",
    viewBox: "0 0 99 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F0AF60",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.923.519c.29-.692 1.282-.692 1.574 0L11.215 4.6c.123.291.4.49.72.516l4.46.353c.755.06 1.062.991.486 1.479l-3.398 2.876a.836.836 0 0 0-.275.835l1.038 4.3c.176.728-.626 1.304-1.273.914l-3.82-2.305a.861.861 0 0 0-.888 0l-3.819 2.305c-.647.39-1.449-.186-1.273-.914l1.038-4.3a.836.836 0 0 0-.274-.835L.538 6.949c-.576-.488-.27-1.42.486-1.48l4.461-.352a.852.852 0 0 0 .719-.516L7.923.519ZM28.252.519c.291-.692 1.283-.692 1.574 0L31.544 4.6c.123.291.4.49.72.516l4.46.353c.756.06 1.062.991.486 1.479l-3.398 2.876a.836.836 0 0 0-.275.835l1.039 4.3c.175.728-.627 1.304-1.274.914l-3.819-2.305a.861.861 0 0 0-.888 0l-3.82 2.305c-.646.39-1.449-.186-1.273-.914l1.039-4.3a.836.836 0 0 0-.275-.835l-3.399-2.876c-.575-.488-.269-1.42.487-1.48l4.46-.352a.852.852 0 0 0 .72-.516L28.251.519ZM48.581.519c.291-.692 1.283-.692 1.574 0L51.874 4.6c.123.291.4.49.719.516l4.46.353c.756.06 1.063.991.487 1.479L54.14 9.825a.836.836 0 0 0-.274.835l1.038 4.3c.176.728-.626 1.304-1.273.914l-3.82-2.305a.861.861 0 0 0-.888 0l-3.819 2.305c-.647.39-1.45-.186-1.273-.914l1.038-4.3a.836.836 0 0 0-.275-.835l-3.398-2.876c-.576-.488-.27-1.42.486-1.48l4.46-.352a.851.851 0 0 0 .72-.516L48.58.519ZM68.91.519c.292-.692 1.283-.692 1.575 0L72.203 4.6c.123.291.4.49.719.516l4.46.353c.756.06 1.063.991.487 1.479l-3.398 2.876a.836.836 0 0 0-.275.835l1.038 4.3c.176.728-.626 1.304-1.273.914l-3.82-2.305a.861.861 0 0 0-.888 0l-3.819 2.305c-.647.39-1.45-.186-1.273-.914l1.038-4.3a.836.836 0 0 0-.274-.835l-3.399-2.876c-.576-.488-.27-1.42.486-1.48l4.461-.352a.852.852 0 0 0 .719-.516L68.911.519ZM89.24.519c.291-.692 1.283-.692 1.574 0L92.533 4.6c.122.291.4.49.718.516l4.461.353c.756.06 1.062.991.486 1.479L94.8 9.825a.836.836 0 0 0-.275.835l1.039 4.3c.176.728-.627 1.304-1.274.914l-3.819-2.305a.861.861 0 0 0-.888 0l-3.82 2.305c-.646.39-1.449-.186-1.273-.914l1.039-4.3a.836.836 0 0 0-.275-.835l-3.398-2.876c-.576-.488-.27-1.42.486-1.48l4.46-.352a.852.852 0 0 0 .72-.516L89.24.519Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.239 0h98.258v16H.239z"
  })))), /*#__PURE__*/React.createElement("blockquote", null, quote.text), /*#__PURE__*/React.createElement("cite", null, quote.name))), /*#__PURE__*/React.createElement("a", {
    onClick: button.onclick,
    rel: "noopener noreferrer",
    target: "_blank",
    href: button.href,
    className: "horizontalProduct_btn"
  }, button.label))));
};
export default HorizontalProduct;